<template>
  <div>
    <navigationFab />

    <v-img
      src="https://images.unsplash.com/photo-1511367461989-f85a21fda167?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1489&q=80"
      gradient="#FFFFFF00, #000000"
      max-height="25vh"
    >
      <v-row>
        <v-col class="mt-16" align="center">
          <span class="primary--text text-md-h2 text-h3 font-weight-bold"
            >Profile</span
          >
        </v-col>
      </v-row>
    </v-img>
    <div v-if="!loading" class="px-8">
      <v-row>
        <v-col cols="3"></v-col>
        <v-col cols="12" md="6" align="center">
          <v-avatar :size="avatarSize">
            <v-img :src="this.profile.images[0].url"></v-img>
          </v-avatar>
        </v-col>
      </v-row>
      <v-row class="my-5">
        <v-col cols="3"></v-col>
        <v-col class="pt-0 mt-n2" cols="12" md="6" align="center">
          <span class="primary--text text-md-h3 text-h4 font-weight-bold">
            {{ profile.display_name }}
          </span>
        </v-col>
      </v-row>
      <v-row class="mt-n3">
        <v-col cols="3"></v-col>
        <v-col class="pt-0 mt-n2" cols="12" md="6" align="center">
          <span class="">
            Not you?
            <span
              class="primary--text text-decoration-underline"
              style="cursor: pointer"
              @click="changeUser"
              >Change User</span
            >
          </span>
        </v-col>
      </v-row>
      <v-row class="mt-5">
        <v-col cols="3"></v-col>
        <v-col class="pt-0 mt-n2" cols="12" md="6" align="center">
          <v-row class="font-weight-bold">
            <v-col>Follower</v-col>
            <v-col>Favourite Genre</v-col>
            <v-col>Favourite Artist</v-col>
            <v-col>Playlist Count</v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="mt-5">
        <v-col cols="3"></v-col>
        <v-col class="pt-0 mt-n2" cols="12" md="6" align="center">
          <v-row>
            <v-col>{{ profile.followers.total }}</v-col>
            <v-col>{{ topArtists.items[0].genres[0] }}</v-col>
            <v-col>{{ topArtists.items[0].name }}</v-col>
            <v-col>{{ userPlaylists.length }}</v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="mt-16 pt-4">
        <v-col cols="3"></v-col>
        <v-col class="pt-0 mt-n2" cols="12" md="6" align="center">
          <v-btn
            color="primary"
            @click="playlistSelection"
            :loading="loadingBtn"
            >Playlist Selection</v-btn
          >
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import navigationFab from "../components/general/navigationFab";
export default {
  name: "Profile",
  title: "Profile",
  components: {
    navigationFab,
  },
  data() {
    return {
      profile: {},
      loading: true,
      topArtists: {},
      loadingBtn: false,
    };
  },
  computed: {
    avatarSize: function () {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 135;
        case "sm":
          return 170;
        case "md":
          return 200;
        case "lg":
          return 200;
        case "xl":
          return 200;
        default:
          return 200;
      }
    },
  },
  methods: {
    changeUser: function () {
      this.$cookies.remove("authToken");
      this.$globalState.topArtists = null;
      this.$globalState.userProfile = null;
      this.$globalState.userPlaylists = null;
      this.$globalState.listify = null;
      window.location = this.$siteUrl + "/redirectSpotify?redirect=%2Fprofile";
    },
    playlistSelection: function () {
      this.loadingBtn = !this.loadingBtn;
      this.$globalState.userPlaylists = [];
      this.$globalState.listify = {};
      this.$router.push("/playlistSelection");
    },
    gettopArtists: async function () {
      let payload = {
        authToken: this.$cookies.get("authToken"),
      };

      let response = await fetch(this.$apiUrl + "/data/topArtists/1", {
        method: "POST",
        body: JSON.stringify(payload),
      });

      let responseData = await response.json();

      if (responseData.state) {
        this.topArtists = responseData.topArtists;
        this.$globalState.topArtists = responseData.topArtists;
      }
    },
    getUserPlaylists: async function () {
      let payload = {
        authToken: this.$cookies.get("authToken"),
      };

      let response = await fetch(this.$apiUrl + "/data/userPlaylists", {
        method: "POST",
        body: JSON.stringify(payload),
      });

      let responseData = await response.json();

      if (responseData.state) {
        this.userPlaylists = responseData.userPlaylists;
        this.$globalState.userPlaylists = responseData.userPlaylists;
      }
    },
  },
  async mounted() {
    // this.profile = this.$cookies.get("userProfile");
    this.profile = this.$globalState.userProfile;

    if (this.$globalState.userPlaylists.length > 0) {
      this.userPlaylists = this.$globalState.userPlaylists;
    } else {
      await this.getUserPlaylists();
    }

    if (this.$globalState.topArtists.items) {
      this.topArtists = this.$globalState.topArtists;
    } else {
      await this.gettopArtists();
    }

    this.loading = false;
  },
};
</script>

<style scoped>
.v-centered {
  display: grid;
  place-items: center end;
}
</style>